import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";
import filterTypes from "data/filter-types";
import { requestCommonDelete, requestCommonFilters, requestCommonSearch } from "../common/requests";
import {
  BIKE_SCAN_TRIGGER_LOADING,
  BIKE_SCAN_TRIGGER_ERROR,
  BIKE_SCAN_TRIGGER_ADD,
  BIKE_SCAN_TRIGGER_UPDATE,
  BIKE_SCAN_TRIGGER_DELETE,
  BIKE_SCAN_TRIGGER_ACTIONS,
  BIKE_SCAN_TRIGGER_FILTERS,
  BIKE_SCAN_TRIGGER_SEARCH,
  BIKE_SCAN_TRIGGER_SINGLE
} from "./constants";
import {
  requestAdd,
  requestUpdate,
  requestGetActions,
} from "./requests";

export const setLoading = (status) => ({
  type: BIKE_SCAN_TRIGGER_LOADING,
  payload: status
});

export const triggerAdd = (data, callback) => dispatch => {
  dispatch(setLoading(true));
  requestAdd(data)
    .then(response => {
      dispatch({
        type: BIKE_SCAN_TRIGGER_ADD,
        payload: response.data
      });
      toast("Trigger created successfully", {
        type: toast.TYPE.SUCCESS,
      });
      callback(true);
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, BIKE_SCAN_TRIGGER_ERROR));
    });
};

export const triggerUpdate = (id, data, callback) => dispatch => {
  dispatch(setLoading(true));
  requestUpdate(id, data)
    .then(response => {
      dispatch({
        type: BIKE_SCAN_TRIGGER_UPDATE,
        payload: response.data
      });
      toast("Trigger updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
      callback(true);
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, BIKE_SCAN_TRIGGER_ERROR));
    });
};

export const triggerDelete = (id) => dispatch => {
  dispatch(setLoading(true));
  requestCommonDelete("bike-scan-trigger", id)
    .then(() => {
      dispatch({
        type: BIKE_SCAN_TRIGGER_DELETE,
        payload: id
      });
      toast("Trigger removed successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, BIKE_SCAN_TRIGGER_ERROR));
    });
};

export const triggerFilters = () => dispatch => {
  requestCommonFilters("bike-scan-trigger")
    .then(response => {
      dispatch({
        type: BIKE_SCAN_TRIGGER_FILTERS,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, BIKE_SCAN_TRIGGER_ERROR));
    });
};

export const triggerSearch = (page = 0, size = 10, sort = "id,asc", criteria) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("bike-scan-trigger", page, size, sort, criteria)
    .then(response => {
      dispatch({
        type: BIKE_SCAN_TRIGGER_SEARCH,
        payload: response
      });
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, BIKE_SCAN_TRIGGER_ERROR));
    });
};

export const triggerSingle = (id) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("bike-scan-trigger", 0, 1, undefined, [{
    fieldName: "id",
    fieldValue: id,
    searchOperation: filterTypes.EQUALS.value
  }])
    .then(response => {
      dispatch({
        type: BIKE_SCAN_TRIGGER_SINGLE,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch(setLoading(false));
      dispatch(defaultErrorHandler(error, BIKE_SCAN_TRIGGER_ERROR));
    });
};

export const triggerGetActions = () => dispatch => {
  requestGetActions()
    .then(response => {
      dispatch({
        type: BIKE_SCAN_TRIGGER_ACTIONS,
        payload: response.data.content
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, BIKE_SCAN_TRIGGER_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/bike-scan-trigger/actions.js